import styled, { css } from 'styled-components';

import { BREAKPOINTS } from '@/constants/breakpoints';
import { flexBetween, flexColumn } from '@/styles/common';

export const Wrapper = styled.div`
  overflow: hidden;
  width: max-content;
  width: 100vw;
  height: 100svh;
  max-width: 100%;
  ${flexColumn}
`;

export const HeaderWrapper = styled.div`
  ${flexBetween};
  position: relative;
  padding-top: 25px;
  padding-inline: 40px;
  padding-bottom: 20px;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding-inline: 16px;
    padding-bottom: 16px;
  }

  @media (max-width: ${BREAKPOINTS.tablet}) {
    &:after {
      position: absolute;
      top: 5px;
      left: 50%;
      width: 65px;
      height: 4px;
      content: ' ';
      transform: translateX(-50%);
      background-color: var(--border-secondary);
    }
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ContentWrapper = styled.div`
  overflow-y: scroll;
  @media (max-width: ${BREAKPOINTS.tablet}) {
    height: 100%;
  }

  background-color: inherit;

  & [data-open='true'] {
    background-color: var(--bg-card);
  }

  &::-webkit-scrollbar {
    background-color: transparent;
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    width: 4px;
    height: 59px;
    border-radius: 7px;
    background-color: #b1b8c6;
  }

  will-change: height;
`;

export const FooterWrapper = styled.div<{ $isOpen: boolean; $isBig: boolean }>`
  bottom: 0%;
  box-shadow: 10px 0 34px rgba(10, 10, 10, 0.05);
  display: flex;
  gap: 20px;

  padding: 10px 40px;
  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding-inline: 16px;
  }

  position: relative;
  background-color: var(--bg-main);
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};

  ${({ $isOpen, $isBig }) =>
    $isOpen &&
    !$isBig &&
    css`
      width: 100vw;
      position: fixed;
      bottom: 0;
      z-index: 56;
    `}
`;

export const CrossButton = styled.button`
  display: flex;
  background: none;
  border: none;
  border-radius: 50%;
  color: var(--textAndLabels-tertiary);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    color: var(--system-yellow);
  }

  & svg {
    width: 16px;
    height: 16px;
  }
`;
